import Vue from "vue";
// Vue 全局混入对象
Vue.mixin({
  computed: {
    isLogin() {
      return this.$store.state.loginStatus;
    },
    breakpoint() {
      return this.$vuetify.breakpoint;
    }
  },
  methods: {
    // 任何组件都可以呼出登录框
    callLogin() {
      this.$store.dispatch("callLogin");
    }
  }
});
